const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the Polls Manager Directive to display a list or table with events to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Events the resource defined to get and set Events data
 */
app.directive('pollsManager', ['Application', 'Authorization', 'Polls', 'Viewables', '$translate', function(Application, Authorization, Polls, Viewables, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        refresh: '=?'
      },
      template: require('../../templates/directives/polls-manager.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.translations = {};

          self.info = {
            list: [],
            loading: false,
            pages: [],
            page: 1,
            perPage: 20,
            fields: 'user,company,author,title,expiration,createdAt,updatedAt,published,linked_category,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades',
            lastPage: null,
            showArchive: false,
            searching: false
          };
          self.isCollaborator = function() {
            return Authorization.isCollaborator();
          };
          self.comms = {
            initialized: false,
            initialize: function() {
              if (!Authorization.getAuthToken().company.engage) {
                Application.navigation.goToHome();
                return;
              }
              this.initialized = true;
              this.get();
            },
            standardQuery: function() {
              var q = {
                page: self.info.page,
                per_page: self.info.perPage,
                fields: self.info.fields,
                'user-populate': 'first_name,last_name,full_name,email'
              };
              if (self.isCollaborator()) {
                q.privacy_collaborators = '$in,1,' + Authorization.getAuthToken().user._id;
              }
              return q;
            },
            query: {
              page: self.info.page,
              per_page: self.info.perPage,
              fields: self.info.fields,
              'user-populate': 'first_name,last_name,full_name,email'
            },
            get: function() {
              if (!self.info.searching && self.info.pages[self.comms.query.page - 1]) {
                self.info.list = self.info.pages[self.comms.query.page - 1];
                if (self.info.list.length < self.info.perPage) {
                  self.info.lastPage = self.comms.query.page;
                }
                return;
              }
              self.info.loading = true;
              if (self.isCollaborator() && !this.query.privacy_collaborators) {
                this.query.privacy_collaborators = '$in,1,' + Authorization.getAuthToken().user._id;
              }
              Polls.find(this.query).$promise
                  .then(function(results) {
                    if (!results || !results.length) {
                      self.info.lastPage = self.comms.query.page - 1;
                    }
                    if (results.length < self.info.perPage) {
                      self.info.lastPage = self.comms.query.page;
                    }

                    if (!self.info.searching) {
                      self.info.pages[self.comms.query.page - 1] = results;
                    }
                    self.info.list = results;
                    self.info.loading = false;
                  }).catch(function(error) {
                self.info.loading = false;
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['pollsManager.error_getting_polls']});
              });
            },
            previous: function() {
              this.query.page--;
              this.get();
            },
            next: function() {
              this.query.page++;
              this.get();
            },
            archive: function() {
              var selection = [];
              if (!self.selections.list || self.selections.list.length === 0) {
                return;
              }
              for (var i = 0; i < self.selections.list.length; i++) {
                selection.push({id: self.selections.list[i], type: 'poll'});
              }
              self.info.loading = true;
              Viewables.archive({}, {content: selection}, function(data) {
                data.archived.forEach(function(archivedItem) {
                  for (var index = self.info.list.length; index >= 0; index--) {
                    if (!self.info.list[index] || !self.info.list[index]._id || self.info.list[index]._id !== archivedItem) {
                      continue;
                    }
                    self.info.list.splice(index, 1);
                    break;
                  }
                });
                Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['pollsManager.all_archived_success']});
                $scope.refresh = 'archived';
                self.info.showArchive = false;
                self.info.loading = false;
                self.selections.list = [];
              }, function(error) {
                console.log('Error archiving content:', error);
                self.info.showArchive = false;
                self.info.loading = false;
              });
            }
          };

          self.selections = {
            list: [],
            select: function(poll) {
              if (!poll || !poll._id) {
                return;
              }
              var existingIndex = this.list.indexOf(poll._id);
              if (existingIndex !== -1) {
                this.list.splice(existingIndex, 1);
                return;
              }
              this.list.push(poll._id);
            }
          };

          self.searchItems = {
            placeholder: self.translations['pollsManager.search_placeholder'],
            onQuery: function(opts) {
              self.comms.query = self.comms.standardQuery();
              self.comms.query.page = 1;
              self.info.searching = false;
              self.info.lastPage = null;

              if (opts && typeof opts === 'object' && Object.keys(opts).length) {
                self.info.searching = true;
              }
              if (!opts) {
                self.comms.get();
                return;
              }

              for (var key in opts) {
                self.comms.query[key] = opts[key];
              }
              self.comms.get();
            }
          };

          $scope.$watch('refresh', function(newVal, oldVal) {
            if (!self.comms.initialized || !newVal || newVal === oldVal) {
              return;
            }
            if (newVal !== 'polls' && newVal !== 'all') {
              return;
            }
            self.info.pages = [];
            self.comms.initialize();
            $scope.refresh = null;
          });

          $translate([
            'smartbar.placeholder.events',
            'modules.notifications.event_wereDeleted',
            'pollsManager.error_getting_polls',
            'pollsManager.all_archived_success',
            'pollsManager.search_placeholder'
          ]).then(function(translations) {
            self.translations = translations;
            self.comms.initialize();
          });
        }],
      controllerAs: 'polls'
    };
  }]);
